[
  {
    "ID":1,
    "title":"Greet with a smile",
    "subtext":"Start the conversation with a bright smile!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":2,
    "title":"Sharing positivity",
    "subtext":"Positive vibes are contagious - share them with the customer!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":3,
    "title":"Being empathic",
    "subtext":"Empathize with the customer and show genuine understanding.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":4,
    "title":"Speak confidently",
    "subtext":"Your voice is strong - speak with confidence!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":5,
    "title":"Addressing customers by name",
    "subtext":"A personal approach with the customer's name works wonders.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":6,
    "title":"Greet warmly",
    "subtext":"A friendly \"Hello!\" puts a smile on the face.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":7,
    "title":"Listen attentively",
    "subtext":"Listen carefully and understand the customer's needs.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":8,
    "title":"Changing topics of conversation smoothly",
    "subtext":"Skillfully switch between topics to keep the conversation flowing.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":9,
    "title":"Offer solutions with a smile",
    "subtext":"Solve problems with a smile - that's the way!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":10,
    "title":"Act carefully",
    "subtext":"Treat each call with care, as if it were a delicate flower.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":11,
    "title":"Use moments of silence",
    "subtext":"Silence can be golden - give the customer time to think.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":12,
    "title":"Mirroring customer voice",
    "subtext":"Mirror the customer's tone and speed for better connection.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":13,
    "title":"Showing product knowledge",
    "subtext":"A professional knows - share your knowledge with the customer.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":14,
    "title":"Inspire with stories",
    "subtext":"Package information in stories - customers love it!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":15,
    "title":"Dealing with challenges confidently",
    "subtext":"A captain on stormy seas - navigate through challenges.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":16,
    "title":"Keep calm",
    "subtext":"Maintain composure even when things get stormy.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":17,
    "title":"Show gratitude",
    "subtext":"Say \"thank you\" for the customer's time - it makes all the difference.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":18,
    "title":"Add a pinch of humor",
    "subtext":"A smile is the best icebreaker - add a dash of humor!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":19,
    "title":"Pick up and expand on customer ideas",
    "subtext":"Customer ideas are treasures - enhance them with your expertise.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":20,
    "title":"Close with confidence",
    "subtext":"Finish confident and satisfied - that's the key!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":21,
    "title":"Using your superhero voice",
    "subtext":"Your voice, your superpower - use it wisely!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":22,
    "title":"Pay attention to details",
    "subtext":"Pay attention to every detail - it can make the difference.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":23,
    "title":"Be flexible",
    "subtext":"Flexibility is key - adapt to customers.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":24,
    "title":"Leave a positive impression",
    "subtext":"Every call leaves a mark - make sure you make a positive impression.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":25,
    "title":"React quickly",
    "subtext":"Answer quickly and accurately - customers appreciate that.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":26,
    "title":"Take responsibility",
    "subtext":"Take responsibility for the call - you have the scepter!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":27,
    "title":"Show emotional intelligence",
    "subtext":"Empathize with the customer - emotions are key.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":28,
    "title":"Overcome setbacks",
    "subtext":"Stand up after setbacks - you are stronger than they are.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":29,
    "title":"Create unforgettable experiences",
    "subtext":"Make the call memorable - the customer will appreciate it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":30,
    "title":"Empowering customers",
    "subtext":"Empower customers to make informed decisions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":31,
    "title":"Be the customer's champion",
    "subtext":"Be the hero the customer needs - make them happy!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":32,
    "title":"Shine with personality",
    "subtext":"Let your personality shine - all ears are on you in the call center.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":33,
    "title":"Exercising patience",
    "subtext":"Patience is a virtue - practice it, especially on the phone.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":34,
    "title":"Enrich conversations with diversity",
    "subtext":"Spice up the conversation with variety and interest.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":35,
    "title":"Exude positive energy",
    "subtext":"Spread positivity like a ray of sunshine - the customer will feel it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":36,
    "title":"Build customer relationships",
    "subtext":"Create a bridge between customer needs and solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":37,
    "title":"Work empathic miracles",
    "subtext":"Empathy conjures a smile - make the customer wonder.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":38,
    "title":"Showing genuine interest",
    "subtext":"Show genuine interest in the customer - it builds trust.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":39,
    "title":"Using persuasive Jedi mind tricks",
    "subtext":"Use your persuasive powers like a Jedi.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":40,
    "title":"Treating customers with respect",
    "subtext":"Treat customers as you would like to be treated - with respect.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":41,
    "title":"Celebrate successes",
    "subtext":"Every success counts - celebrate it with the customer!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":42,
    "title":"Prioritize customer satisfaction",
    "subtext":"Think customer satisfaction, not just sales.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":43,
    "title":"Inspire with your appearance",
    "subtext":"Make every call a rousing show!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":44,
    "title":"Handle challenging conversations with care",
    "subtext":"Navigate skillfully through difficult conversations.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":45,
    "title":"Going on an exciting adventure",
    "subtext":"Think of every call as an exciting adventure!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":46,
    "title":"Show understanding",
    "subtext":"With \"I understand\" you show understanding - one small step for you, one big step for the customer.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":47,
    "title":"Activate your superpower of listening",
    "subtext":"Listen carefully - that's your superpower!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":48,
    "title":"Make a real impact",
    "subtext":"Adapt your approach to get real results.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":49,
    "title":"Establish real connection",
    "subtext":"Real connections are valuable - create them beyond the call.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":50,
    "title":"Acknowledge feelings and concerns",
    "subtext":"Acknowledgement is key - show understanding of feelings and concerns.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":51,
    "title":"Reassure with a smile",
    "subtext":"A smile can be reassuring - even in challenging situations.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":52,
    "title":"Brighten the day",
    "subtext":"Bring brightness to the customer's day - with your positive approach.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":53,
    "title":"Exploring shared goals",
    "subtext":"Explore common goals and create connections.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":54,
    "title":"Scoring points with empathy",
    "subtext":"Score points with empathy - the customer will appreciate it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":55,
    "title":"Presenting solutions with enthusiasm",
    "subtext":"Present solutions with passion and enthusiasm.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":56,
    "title":"Mastering the art of dealing with complaints",
    "subtext":"Surround complaints with your magic - find solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":57,
    "title":"Building a bridge to solutions",
    "subtext":"Build a bridge to solutions and make the customer experience great.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":58,
    "title":"Being the gleam in the customer's eye",
    "subtext":"Be the gleam in the customer's eye - with your exceptional service.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":59,
    "title":"Capturing the customer's heart",
    "subtext":"Conquer the customer's heart - you are the hero!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":60,
    "title":"Working toward five-star service",
    "subtext":"Strive for service that earns five stars - every call counts.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":61,
    "title":"Sharing customer success stories",
    "subtext":"Share inspiring success stories from other customers.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":62,
    "title":"Be the voice of positivity",
    "subtext":"Let your voice shine with positivity - the customer will hear it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":63,
    "title":"Be the detective of desires",
    "subtext":"Uncover hidden wants and needs like a detective.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":64,
    "title":"Offering a generous helping of security",
    "subtext":"Offer generous security - the customer will appreciate it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":65,
    "title":"Playing the tune of empowerment",
    "subtext":"Help the customer make confident decisions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":66,
    "title":"Glow in the dark",
    "subtext":"Illuminate customer solutions with your expertise - be the beacon!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":67,
    "title":"Mastering the art of kindness",
    "subtext":"Turn friendliness into an art - the customer will feel it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":68,
    "title":"Leading customers to success",
    "subtext":"Lead the customer on the path to success - you are the guide!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":69,
    "title":"Ignite the flame of curiosity",
    "subtext":"Arouse the customer's curiosity and discover preferences.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":70,
    "title":"Brighten the day with positivity",
    "subtext":"Brighten the customer's day with positivity - you make the difference.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":71,
    "title":"Embracing the spirit of collaboration",
    "subtext":"Work with the customer to find the best solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":72,
    "title":"Serving up a generous helping of patience",
    "subtext":"Offer generous patience, especially in difficult conversations.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":73,
    "title":"Create a symphony of customer service",
    "subtext":"Harmonize every aspect of customer service like a symphony.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":74,
    "title":"Being the captain of customer satisfaction",
    "subtext":"Steer the call toward customer satisfaction - you're in the driver's seat!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":75,
    "title":"Offering a pinch of hope",
    "subtext":"Give hope and optimism in difficult situations.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":76,
    "title":"Juggle customer inquiries with ease",
    "subtext":"Juggle multiple requests with confidence - you've got it!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":77,
    "title":"Being the conductor of finding solutions",
    "subtext":"Steer the conversation toward quick solutions - you're the conductor!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":78,
    "title":"Putting your heart into the call",
    "subtext":"Frame every call with genuine care and passion.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":79,
    "title":"Empowering customers with knowledge",
    "subtext":"Share knowledge to enable informed decisions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":80,
    "title":"Be the friendly wizard of support",
    "subtext":"Support the customer with your friendly magic.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":81,
    "title":"Embracing the art of gratitude",
    "subtext":"Be grateful for the customer's time - it makes the difference.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":82,
    "title":"Putting solutions in the spotlight",
    "subtext":"Highlight solutions like a spotlight on stage.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":83,
    "title":"Be the charming tour guide",
    "subtext":"Lead the customer on a delightful journey through the conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":84,
    "title":"Be the maestro of customer service",
    "subtext":"Guide the conversation with outstanding customer service skills.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":85,
    "title":"Sowing seeds of positivity",
    "subtext":"Sow seeds of positivity for a successful interaction.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":86,
    "title":"Approach every call with full commitment",
    "subtext":"Give full effort in every call - you are a professional!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":87,
    "title":"Be the composer of customer happiness",
    "subtext":"Create customer happiness through the melody of the conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":88,
    "title":"Harnessing the magic of solution diversity",
    "subtext":"Surprise with creative solutions - harness the magic of diversity.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":89,
    "title":"Invest in customer relationships",
    "subtext":"Invest in customer relationships like valuable treasures.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":90,
    "title":"Be the architect of satisfaction",
    "subtext":"Build the foundation for customer satisfaction.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":91,
    "title":"Say goodbye to customers with a smile",
    "subtext":"Say goodbye to customers with a warm smile.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":92,
    "title":"Be the queen of customer service",
    "subtext":"Treat customers like royalty - you are the queen of service!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":93,
    "title":"Reveal the secret of listening",
    "subtext":"Share the secret of active listening with customers.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":94,
    "title":"Be a firework of kindness",
    "subtext":"Ignite a fireworks display of kindness in every conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":95,
    "title":"Using the magic of the smile",
    "subtext":"Use the magic of a smile as a powerful tool.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":96,
    "title":"Building the bridge to the solution",
    "subtext":"Build a bridge between customer problems and solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":97,
    "title":"Connecting customer needs with emotions",
    "subtext":"Use emotion to connect with customers.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":98,
    "title":"Using the power of vocabulary",
    "subtext":"Use words as a powerful tool in every call.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":99,
    "title":"Mastering the choreography of customer satisfaction",
    "subtext":"Master the dance steps of customer satisfaction.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":100,
    "title":"Enlightening customers with a beacon of solutions",
    "subtext":"Enlighten customers with a beacon of solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":101,
    "title":"Harnessing the power of words",
    "subtext":"Use your words to delight and persuade customers.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":102,
    "title":"Treating customers like friends",
    "subtext":"Treat customers like friends - create an atmosphere of trust.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":103,
    "title":"Reach your goal with passion",
    "subtext":"Pursue every goal with passion - success will follow.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":104,
    "title":"Knowing the secret ingredient of smiling",
    "subtext":"A smile is your secret ingredient - use it in every call.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":105,
    "title":"Unleashing creativity",
    "subtext":"Unleash your creativity and find unique solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":106,
    "title":"Mastering the art of connection",
    "subtext":"Master the art of building genuine connections.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":107,
    "title":"Be a rock in the surf",
    "subtext":"Be a rock - stable and reliable.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":108,
    "title":"Inspire with a touch of magic",
    "subtext":"Add a touch of magic to the conversation - the customer will be enchanted.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":109,
    "title":"Be a puzzle master of customer needs",
    "subtext":"Unravel the mysteries of customer needs.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":110,
    "title":"Ignite the spark of curiosity",
    "subtext":"Ignite the spark of curiosity in the customer - explore needs.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":111,
    "title":"Mastering the art of friendly persuasion",
    "subtext":"Convince with friendliness - this is the real art.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":112,
    "title":"Putting the customer first",
    "subtext":"Put the customer in the center of your actions - he is the star!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":113,
    "title":"Shine with knowledge",
    "subtext":"Share knowledge like a diamond - the customer will benefit from it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":114,
    "title":"Offer simplicity and clarity",
    "subtext":"Offer simplicity and clarity - the customer will appreciate it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":115,
    "title":"Be the captain of your conversation",
    "subtext":"You are the captain directing the conversation - off to a successful journey!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":116,
    "title":"Mastering the art of small talk",
    "subtext":"Master the art of small talk - open the conversation with ease.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":117,
    "title":"Throw the party of customer satisfaction",
    "subtext":"Throw the party of customer satisfaction - let the customer celebrate!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":118,
    "title":"Unleashing the power of words",
    "subtext":"Unleash the power of your words - influence positively.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":119,
    "title":"Have an ace up your sleeve",
    "subtext":"Always have an ace up your sleeve - be prepared for anything.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":120,
    "title":"Treating customers like kings",
    "subtext":"Treat customers like royalty - they deserve royal service.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":121,
    "title":"Using the magic of surprise",
    "subtext":"Use the magic of surprise to spice up the conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":122,
    "title":"Walk in customer shoes",
    "subtext":"Put yourself in the customer's shoes - understand what they need.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":123,
    "title":"Be the champion of customer satisfaction",
    "subtext":"Be the champion of customer satisfaction - capture hearts.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":124,
    "title":"Guiding the customer through the conversation",
    "subtext":"Guide the customer through the conversation with skill and care.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":125,
    "title":"Harnessing the superpowers of finding solutions",
    "subtext":"Use your superpowers to find solutions - you've got them!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":126,
    "title":"Inspire with cleverness and finesse",
    "subtext":"Inspire with cleverness and finesse - the customer will be impressed.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":127,
    "title":"Being a lightning bolt of inspiration",
    "subtext":"Be a bolt of inspiration - bring a breath of fresh air to the conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":128,
    "title":"Listening to and meeting customer needs",
    "subtext":"Listen to customer wishes and fulfill them - that is the way to success.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":129,
    "title":"Communicate with heart and mind",
    "subtext":"Communicate with heart and mind - create emotional connection.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":130,
    "title":"Roll out the red carpet of solutions",
    "subtext":"Roll out the red carpet of solutions - the customer will love it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":131,
    "title":"Use the magic of demand",
    "subtext":"Use the magic of demand to explore needs.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":132,
    "title":"Being the captain of the successful conversation",
    "subtext":"Be the captain of the successful conversation - off to new shores!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":133,
    "title":"A dash of sympathy for the soul",
    "subtext":"Inject sympathy into the conversation - touch the customer's soul.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":134,
    "title":"Analyze customer needs like a pro",
    "subtext":"Analyze customer needs like a pro - find the key.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":135,
    "title":"Shine with personality and creativity",
    "subtext":"Shine with personality and creativity - be a star in the conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":136,
    "title":"Opening the door to customer satisfaction",
    "subtext":"Open the door to customer satisfaction - the customer will come in!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":137,
    "title":"Knowing the magic formula for customer conversations",
    "subtext":"Do you know the magic formula? It's: kindness, empathy, solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":138,
    "title":"Start the call with a smile",
    "subtext":"Start with a smile - that will transfer to the customer.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":139,
    "title":"Uncovering the secrets of customer satisfaction",
    "subtext":"Unlock the secrets of customer satisfaction - be the master!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":140,
    "title":"Delight customers with a touch of magic",
    "subtext":"Delight customers with a touch of magic - conjure up a smile.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":141,
    "title":"Finding the key to customer satisfaction",
    "subtext":"Find the key to customer satisfaction - it's in your hand.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":142,
    "title":"Pampering customers with glitz and glamour",
    "subtext":"Pamper customers with glitz and glamour - it's the details that count.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":143,
    "title":"Connecting with a sense of humor",
    "subtext":"Connect with a pinch of humor - this loosens up the conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":144,
    "title":"Harnessing the power of empathy",
    "subtext":"Use the power of empathy - the customer will feel understood.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":145,
    "title":"Finding the way to the customer's heart",
    "subtext":"Find the way to the customer's heart - it is in the customer's real interest.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":146,
    "title":"Shaping the journey of satisfaction together",
    "subtext":"Create the journey to satisfaction together - you are the guide.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":147,
    "title":"Treating customers like queens",
    "subtext":"Treat customers like queens - they deserve royal service.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":148,
    "title":"Exploring the science of customer happiness",
    "subtext":"Explore the science of customer happiness - be an explorer!",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":149,
    "title":"Communicating with a smile in your heart",
    "subtext":"Communicate with a smile in your heart - it transfers to the customer.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":150,
    "title":"Meeting customer needs with creativity",
    "subtext":"Meet customer needs with creativity and innovation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":151,
    "title":"Harnessing the power of teamwork",
    "subtext":"Use the power of teamwork to find solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":152,
    "title":"Walking through challenges with serenity",
    "subtext":"Walk calmly through challenges - you've got it covered.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":153,
    "title":"Ignite the spark of trust",
    "subtext":"Ignite the spark of trust - create a trusting relationship.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":154,
    "title":"Be a master of smiles",
    "subtext":"Become a master of the smile - use it in every conversation.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":155,
    "title":"Harnessing the magic of relationship development",
    "subtext":"Use the magic of relationship development - customer loyalty is key.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":156,
    "title":"Sharing the energy of positivity",
    "subtext":"Share the energy of positivity - it's contagious.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":157,
    "title":"Unleashing the magic of appreciation",
    "subtext":"Unleash the magic of appreciation - the customer will feel valued.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":158,
    "title":"Treating customers like gems",
    "subtext":"Treat customers like gems - carefully and with value.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":159,
    "title":"Mastering the art of sympathy",
    "subtext":"Master the art of sympathy - be empathetic and understanding.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":160,
    "title":"Opening the door to sales opportunities",
    "subtext":"Open the door to sales opportunities - find the perfect solution.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":161,
    "title":"Shine with patience and attention to detail",
    "subtext":"Shine with patience and attention to detail - the customer will notice.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":162,
    "title":"Treating the customer like a star",
    "subtext":"Treat the customer like a star - you are the VIP manager.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":163,
    "title":"Harnessing the magic of simplicity",
    "subtext":"Use the magic of simplicity - clear solutions are the key.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":164,
    "title":"Mastering the art of active listening",
    "subtext":"Master the art of active listening - the customer will feel understood.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":165,
    "title":"Identify customer needs with foresight",
    "subtext":"Identify customer needs with foresight - offer customized solutions.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":166,
    "title":"Attend the master class in customer interaction",
    "subtext":"Attend the master class of customer interaction - become a professional.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":167,
    "title":"Inspire customers with a spark of enthusiasm",
    "subtext":"Inspire customers with a spark of enthusiasm - it works wonders.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":168,
    "title":"Harnessing the magic of customer expectations",
    "subtext":"Harness the magic of customer expectations - exceed them with your service.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":169,
    "title":"Treating the customer like a friend",
    "subtext":"Treat the customer like a friend - create a familiar atmosphere.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":170,
    "title":"Inspire with energy and passion",
    "subtext":"Inspire with energy and passion - this transfers to the customer.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":171,
    "title":"Mastering the art of empathy",
    "subtext":"Master the art of empathy - be on the same wavelength.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":172,
    "title":"Enchanting the customer with a ray of sunshine",
    "subtext":"Enchant the customer with a sunbeam of positivity.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":173,
    "title":"Harnessing the wisdom of the customer experience",
    "subtext":"Use the wisdom of the customer experience - it's your guide.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":174,
    "title":"Connecting with warmth and authenticity",
    "subtext":"Connect with warmth of heart and authenticity - the customer will open up.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":175,
    "title":"Mastering the master class of finding solutions",
    "subtext":"Master the master class of finding solutions - be the expert.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":176,
    "title":"Infect customers with a spell of enthusiasm",
    "subtext":"Infect customers with enthusiasm - sparks will fly.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":177,
    "title":"Unleashing the power of appreciation",
    "subtext":"Unleash the power of appreciation - the customer will appreciate it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":178,
    "title":"Treating the customer like a partner",
    "subtext":"Treat the customer like a partner - you are a team.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":179,
    "title":"Convince with joy and commitment",
    "subtext":"Convince with joy and commitment - the customer will follow you.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":180,
    "title":"Mastering the strategy of listening",
    "subtext":"Master the strategy of listening - the customer will feel it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":181,
    "title":"Communicate with charisma and heart",
    "subtext":"Communicate with charisma and heart - the customer will feel comfortable.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":182,
    "title":"Surprise customers with a touch of magic",
    "subtext":"Surprise customers with a touch of magic - they will love it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":183,
    "title":"Attend the customer service master class",
    "subtext":"Attend the master class of customer service - become an expert.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":184,
    "title":"Shine with expertise and enthusiasm",
    "subtext":"Shine with expertise and enthusiasm - you are the expert.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":185,
    "title":"Enchant customers with a smile",
    "subtext":"Enchant the customer with a radiant smile.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":186,
    "title":"Shape the customer satisfaction journey",
    "subtext":"Create the journey of customer satisfaction - be the tour guide.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":187,
    "title":"Delight with a smile in your heart",
    "subtext":"Delight with a smile in your heart - the customer will feel it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":188,
    "title":"Mastering the art of customer loyalty",
    "subtext":"Master the art of customer loyalty - create long-lasting relationships.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":189,
    "title":"Convincing the customer with ease",
    "subtext":"Convince the customer with ease - you are a professional.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":190,
    "title":"Sharing the energy of enthusiasm",
    "subtext":"Share the energy of enthusiasm - the customer will join in.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":191,
    "title":"Connecting with authenticity and dedication",
    "subtext":"Connect with authenticity and dedication - the customer will trust.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":192,
    "title":"Playing the melody of customer delight",
    "subtext":"Play the melody of customer delight - make the conversation a symphony.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":193,
    "title":"Harnessing the magic of customer empathy",
    "subtext":"Use the magic of customer empathy - you will connect.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":194,
    "title":"Shine with professionalism and respect",
    "subtext":"Shine with professionalism and respect - the customer will appreciate it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":195,
    "title":"Using the magic of the willingness to solve",
    "subtext":"Use the magic of willingness to solve - the customer will be relieved.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":196,
    "title":"Treating the customer like a guest",
    "subtext":"Treat the customer like a valued guest - create a positive experience.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":197,
    "title":"Inspire with warmth and expertise",
    "subtext":"Inspire with warmth and expertise - you are the expert.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":198,
    "title":"Mastering the master class of communication",
    "subtext":"Master the master class of communication - be the communication guru.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":199,
    "title":"Inspire customers with a sparkle of enthusiasm",
    "subtext":"Delight customers with a sparkle of enthusiasm - radiate positivity.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "ID":200,
    "title":"Treating customer satisfaction like a treasure",
    "subtext":"Treat customer satisfaction like a treasure - nurture and protect it.",
    "logic":"before-the-call",
    "topic":"generic-phrases",
    "category":"generic"
  },
  {
    "title":"Good morning!",
    "category":"morning",
    "subtext":"Wishing you a bright and sunny day!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Rise and shine!",
    "category":"morning",
    "subtext":"Start your day with a smile!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Have a wonderful morning!",
    "category":"morning",
    "subtext":"May your morning be filled with joy and positivity!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Good day to you!",
    "category":"morning",
    "subtext":"Sending you warm greetings for a beautiful morning!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Enjoy the morning!",
    "category":"morning",
    "subtext":"Enjoy the freshness of the morning!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Have an amazing morning!",
    "category":"morning",
    "subtext":"May your day begin on a perfect note!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Good morning, sunshine!",
    "category":"morning",
    "subtext":"Sending you good vibes for a fantastic morning!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Start your day with a smile!",
    "category":"morning",
    "subtext":"Believe in yourself and all that you are capable of achieving.",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Hello, new day!",
    "category":"morning",
    "subtext":"Today is a fresh start, a new beginning. Make it count",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Morning is calling",
    "category":"morning",
    "subtext":"The early bird catches the worm, have a successful day!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"A new day begins!",
    "category":"morning",
    "subtext":"Let us fill the world with kindness and smiles.",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Start the day well!",
    "category":"morning",
    "subtext":"The early bird gets the worm.",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Have a wonderful day!",
    "category":"morning",
    "subtext":"Morning makes the day!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Welcome to a brand new day!",
    "category":"morning",
    "subtext":"Wishing you a day full of joy and productivity",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Good afternoon!",
    "category":"afternoon",
    "subtext":"Remember, every small step counts towards achieving your goals",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Pleasant afternoon to you!",
    "category":"afternoon",
    "subtext":"You're doing an amazing job!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Hello, it's the afternoon!",
    "category":"afternoon",
    "subtext":"Stay focused and keep your eyes on the prize!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Wishing you a lovely afternoon!",
    "category":"afternoon",
    "subtext":"Take a few minutes of quiet reflection.",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Have a wonderful afternoon!",
    "category":"afternoon",
    "subtext":"Every small step adds up to your goals.",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Keep pushing through!",
    "category":"afternoon",
    "subtext":"You're rocking it, don't slow down!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"So far so good?",
    "category":"afternoon",
    "subtext":"Midday reminder: Stay on track and keep rocking!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Hello, World!",
    "category":"afternoon",
    "subtext":"Let the good vibes flow!",
    "logic":"before-the-call",
    "topic":"greeting-based-on-time-of-the-day"
  },
  {
    "title":"Congratulations on your #ordinal# call!",
    "group":1,
    "subtext":"Keep up the good work and stay focused on the goal.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Way to go on your #ordinal# call!",
    "group": 1,
    "subtext":"Continue pushing forward and maintain your sight on the objective.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Bravo on making your #ordinal# call!",
    "group": 1,
    "subtext":"Stay on track and keep your eyes fixed on the target.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"High-five on your #ordinal# call!",
    "group": 1,
    "subtext":"Keep the momentum going and don't lose sight of the end goal.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Well done on your #ordinal# call!",
    "group": 1,
    "subtext":"Stay committed to reaching the objective.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Hooray!",
    "group": 1,
    "subtext":"Stay persistent and be mindful of the desired outcome.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Fantastic job on your #ordinal# call!",
    "group": 1,
    "subtext":"Keep driving forward and keep your attention on the goal.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Thumbs up for your #ordinal# call!",
    "group": 1,
    "subtext":"Time to move on to the next call.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Cheers to your #ordinal# call!",
    "group": 1,
    "subtext":"Let's proceed to the next call.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"#ordinal# call well done!",
    "group": 1,
    "subtext":"Time to shift gears to the next call",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Outstanding work!",
    "group":2,
    "subtext":"You've completed a total of #numberOfCalls# #calls# today!",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Impressive work!",
    "group": 2,
    "subtext":"You've successfully finished #numberOfCalls# #calls# today.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Give yourself a round of applause!",
    "group": 2,
    "subtext":"Great job on handling #numberOfCalls# #calls# today!",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Well done!",
    "group": 2,
    "subtext":"You've accomplished #numberOfCalls# #calls# today.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Fantastic job!",
    "group": 2,
    "subtext":"You've successfully completed #numberOfCalls# #calls# today.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"You're crushing it!",
    "group": 2,
    "subtext":"You've managed to finish #numberOfCalls# #calls# today.",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"You're on fire!",
    "group": 2,
    "subtext":"Excellent work on handling #numberOfCalls# #calls# today!",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"You're making incredible progress!",
    "group": 2,
    "subtext":"You've hit the milestone with your #numberOfCalls# call, way to go!",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Way to go!",
    "group": 2,
    "subtext":"#numberOfCalls# #calls# tackled and conquered today!",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  },
  {
    "title":"Unstoppable!",
    "group": 2,
    "subtext":"You've made it to #numberOfCalls# #calls# already!",
    "logic":"after-the-call",
    "topic":"call-related-call-count",
    "category":"after-the-x-call"
  }
]
